<button *ngIf="canAttachFilesToObservation()" type="button" class="btn btn-sm btn-info" (click)="openAttachmentModal()" title="Attachments">
  <strong><i class="fas fa-paperclip text-primary"></i></strong> <span class="badge bg-primary ms-2">{{observationFiles.length}}</span>
</button>
